/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Components_Upgrade_Plan_Modal_Features_MessagesInputs */

const es_components_upgrade_plan_modal_features_messages = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_MessagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} mensajes por mes`)
};

const en_components_upgrade_plan_modal_features_messages = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_MessagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} messages per month`)
};

/**
* | output |
* | --- |
* | "{value} messages per month" |
*
* @param {Components_Upgrade_Plan_Modal_Features_MessagesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_messages = /** @type {((inputs: Components_Upgrade_Plan_Modal_Features_MessagesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_MessagesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_messages(inputs)
	return en_components_upgrade_plan_modal_features_messages(inputs)
});
export { components_upgrade_plan_modal_features_messages as "components.upgrade_plan_modal.features.messages" }